
import { createPostApi } from "../../../../callApi/postApi";
import CustomHeader from "../../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../../components/admin/CustomLeftBar";
import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import Notiflix from "notiflix";
import CustomInputProduct from "../../../../components/CustomInputProduct";
import CustomHtmlEditor from "../../../../components/CustomHtmlEditor";
import { UploadImgApi } from "../../../../callApi/upload";
import { useNavigate } from "react-router-dom";

export default function AdminPostAdd() {
  const [title, settitle] = useState("");
  const router = useNavigate();
  const [post_categories, setpost_categories] = useState(null);
  const [htmlEditorArray, sethtmlEditorArray] = useState([]);
  useEffect(() => {}, []);
  const saveData = async () => {
    try {
      if (post_categories != null) {
        Notiflix.Loading.circle();
        let tempHtml = [];
        let error = null;
        for (let i = 0; i < htmlEditorArray.length; i++) {
        let tempHtmlArray = [];
          for (let j = 0; j < htmlEditorArray[i].length; j++) {
            if (
              htmlEditorArray[i][j].value != "" ||
              htmlEditorArray[i][j].value != null ||
              htmlEditorArray[i][j].value != undefined
            ) {
              if (htmlEditorArray[i][j].type == "image") {
                const res = await UploadImgApi({file:htmlEditorArray[i][j].value});
                if (res.status == 200 || res.status == 201) {
                  tempHtmlArray.push({
                    type: htmlEditorArray[i][j].type,
                    value: res.data.data.img,
                  });
                }
              } else {
                tempHtmlArray.push({
                  type: htmlEditorArray[i][j].type,
                  value: htmlEditorArray[i][j].value,
                });
              }
            } else {
              error = "กรุณาใส่ข้อมูลให้ครบถ้วน";
              break;
            }
          }
          tempHtml.push(tempHtmlArray)
          if (error != null) {
            break;
          }
        }
        if (error != null) {
          Notiflix.Notify.warning(error);
          return;
        }
        const html = JSON.stringify({ html: tempHtml });
        const res = await createPostApi({
          content: html,
          content_json:{ html: tempHtml },
          title: title,
          post_categories_id: post_categories.id,
        });
        Notiflix.Loading.remove();
        if (res.status == 200) {
          Notiflix.Notify.success("Success");
          router(-1);
        } else {
          Notiflix.Notify.failure("Error");
        }
      } else {
        Notiflix.Notify.warning("กรุณาเลือกประเภท");
      }
    } catch (error) {
      Notiflix.Loading.remove();
      Notiflix.Notify.failure("Error");
    }
  };

  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Posts" subPage="Add New Post" />
        <div className="p-8 flex flex-col items-center flex-[1] overflow-y-auto ">
          <p className="font_Kanit text-[24px] w-full font-semibold">
            เพิ่มโพสบทความใหม่
          </p>
          <div className="w-full flex flex-row gap-4 z-10">
            <CustomInputProduct
              value={post_categories}
              onChange={(v) => setpost_categories(v)}
              title="ประเภท"
              placeHolder="กรุณาเลือกประเภท"
              fontSize={14}
              type={"select"}
              data={[
                { name: "News&Event", id: 1 },
                { name: "Knowledge", id: 2 },
              ]}
            />
            <CustomInputProduct
              value={title}
              onChange={(v) => settitle(v)}
              title="ชื่อเรื่อง"
              placeHolder="กรุณาใส่ชื่อเรื่อง"
              fontSize={14}
            />
          </div>
          <div className="overflow-x-auto w-full flex-[1] my-5 h-full">
            <CustomHtmlEditor
              initial={htmlEditorArray}
              onChange={sethtmlEditorArray}
            />
          </div>

          <div className=" flex flex-row gap-3 my-6 justify-center items-center">
            <CustomButton
            leftIconName={'uil:save'}
              txt={"Save"}
              bgcolor="#2271B1"
              onClick={() => {
                saveData();
              }}
            />
            <CustomButton
              txt={"Cancel"}
              bgcolor="#9E0400"
              onClick={() => {
                router(-1);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
